<!--
    描述：问题信息
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-page-main">
        <!-- 顶部搜索栏 -->
        <div class="w-page-header">
            <search-area ref="searchContent" v-model="searchForm.userName" placeholderName="用户账号"
                @on-search="onSearch" @on-refresh="onRefresh" @on-reset="onReset">
                <el-form slot="searchform"
                         :model="searchForm"
                         label-width="90px">
                    <el-form-item label="开始日期">
                        <el-date-picker v-model="searchForm.startDate" type="date" placeholder="请选择"
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期">
                        <el-date-picker v-model="searchForm.endDate" type="date" placeholder="请选择"
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="IP地址">
                        <el-input placeholder="请输入" v-model="searchForm.ip"></el-input>
                    </el-form-item>
                    <el-form-item label="方法名称">
                        <el-input placeholder="请输入" v-model="searchForm.method"></el-input>
                    </el-form-item>
                    <el-form-item label="请求URL">
                        <el-input placeholder="请输入" v-model="searchForm.urlPath"></el-input>
                    </el-form-item>
                    <el-form-item label="触发位置">
                        <el-radio v-model="searchForm.isAround" :label="1">前端</el-radio>
                        <el-radio v-model="searchForm.isAround" :label="0">后台</el-radio>
                    </el-form-item>
                </el-form>
            </search-area>
        </div>

        <!-- 下方内容 -->
        <div class="w-page-container">
            <problemList ref="listTable"></problemList>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import searchArea from '../../../components/searchArea/searchArea'
    import problemList from './components/exception_list'
    export default {
        components: {searchArea,problemList},
        props : {},
        data() {
            return {
                searchForm : {
                    userName : '',
                    startDate : '',
                    endDate : '',
                    ip : '',
                    method : '',
                    urlPath : '',
                    isAround : '',
                },
            }
        },
        computed: {
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        created() {},
        methods: {
            // 确认搜索
            onSearch() {
                let startDate = this.searchForm.startDate
                let endDate = this.searchForm.endDate
                let sDate = null
                let eDate = null
                if(startDate != null && startDate !='' && typeof(startDate) != 'undefined') sDate = new Date(startDate)

                if(endDate != null && endDate !='' && typeof(endDate) != 'undefined') eDate = new Date(endDate)

                if(startDate != null && startDate !='' && typeof(startDate) != 'undefined'
                    && endDate != null && endDate !='' && typeof(endDate) != 'undefined'
                    && sDate.getTime() > eDate.getTime()
                ) {
                    this.$message({message: '开始时间不能大于结束时间',type: 'warning'});
                    return
                }
                this.$refs.listTable.searchPageList(this.searchForm);
            },

            // 点击刷新
            onRefresh() {
                this.onReset();
                this.onSearch()
            },

            // 点击重置
            onReset() {
                this.$refs.searchContent.userName = ''
                this.searchForm.userName = ''
                this.searchForm.startDate = ''
                this.searchForm.endDate = ''
                this.searchForm.ip = ''
                this.searchForm.method = ''
                this.searchForm.urlPath = ''
                this.searchForm.isAround = ''
            }
        }
    }
</script>

<style scoped>

</style>